export const PLAYER_SET_PLAYING_TRACK = 'PLAYER_SET_PLAYING_TRACK';
export const PLAYER_REMOVE_PLAYING_TRACK = 'PLAYER_REMOVE_PLAYING_TRACK';
export const PLAYER_WAS_TRACK_PLAYED = 'PLAYER_WAS_TRACK_PLAYED';
